import type { ReactNode } from 'react';

import { Logo, MascotWave } from '../../components/brand.tsx';
import { useLang } from '../../i18n.ts';
import { AuthToolbar } from './AuthToolbar.tsx';

/** Sign-in screens: a brand panel (large screens) and the form. */
export function AuthLayout({
  title,
  subtitle,
  children,
}: {
  readonly title: string;
  readonly subtitle?: string | undefined;
  readonly children: ReactNode;
}) {
  const { t } = useLang();
  return (
    <div className="grid min-h-dvh lg:grid-cols-[minmax(0,5fr)_minmax(0,6fr)]">
      <div className="relative hidden overflow-hidden bg-gradient-to-br from-brand-red to-brand-deep-red lg:flex lg:flex-col lg:items-center lg:justify-center">
        <div
          aria-hidden
          className="absolute -top-24 -end-24 size-80 rounded-full bg-brand-light-orange/30"
        />
        <div
          aria-hidden
          className="absolute -bottom-32 -start-16 size-96 rounded-full bg-brand-yellow/20"
        />
        <MascotWave className="relative w-80 max-w-[70%] drop-shadow-2xl" />
        <p className="relative mt-6 text-3xl font-bold text-white">{t('app.name')}</p>
        <p className="relative mt-1 text-lg text-white/90">{t('app.product')}</p>
      </div>
      <div className="flex flex-col">
        <AuthToolbar />
        <main className="flex flex-1 items-center justify-center px-4 pb-12">
          <div className="w-full max-w-md">
            <Logo className="mx-auto mb-8 h-24 w-auto" />
            <div className="rounded-2xl border border-border bg-surface p-6 shadow-sm sm:p-8">
              <h1 className="text-2xl font-bold">{title}</h1>
              {subtitle ? <p className="mt-1 text-sm text-muted">{subtitle}</p> : null}
              <div className="mt-6">{children}</div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
